import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "fixed inset-0 z-[60] flex items-center justify-center p-4 md:p-8",
    role: "dialog",
    "aria-modal": "true"
};
const _hoisted_2 = { class: "relative z-10 w-full max-w-2xl max-h-[85vh] overflow-y-auto bg-offWhite dark:bg-darkBg border border-black/10 dark:border-white/10 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.5)]" };
const _hoisted_3 = { class: "sticky top-0 z-10 bg-offWhite dark:bg-darkBg flex items-start justify-between gap-4 p-6 md:p-8 border-b border-black/10 dark:border-white/10" };
const _hoisted_4 = { class: "text-sm font-mono uppercase tracking-widest opacity-50 mb-2" };
const _hoisted_5 = {
    key: 0,
    class: "text-xl md:text-2xl font-black uppercase tracking-tight leading-tight"
};
const _hoisted_6 = { class: "p-6 md:p-8" };
const _hoisted_7 = {
    key: 0,
    class: "grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3"
};
const _hoisted_8 = {
    key: 0,
    class: "shrink-0 px-2 py-0.5 bg-accent/15 text-accent text-[10px] font-bold uppercase tracking-wider"
};
const _hoisted_9 = {
    key: 1,
    class: "text-sm opacity-50"
};
import { computed, watch, onUnmounted } from "vue";
import { Icon } from "@iconify/vue";
import { CONTENT } from "../constants";
import { useLanguage } from "../composables/useLanguage";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SkillsModal',
    props: {
        open: { type: Boolean },
        study: {},
        skills: {}
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { language } = useLanguage();
        const text = computed(() => CONTENT[language.value]);
        const onKey = (e) => {
            if (e.key === "Escape")
                emit("close");
        };
        // Toggle the ESC listener and body scroll lock with the modal's visibility.
        watch(() => props.open, (isOpen) => {
            if (typeof document === "undefined")
                return;
            if (isOpen) {
                document.addEventListener("keydown", onKey);
                document.body.style.overflow = "hidden";
            }
            else {
                document.removeEventListener("keydown", onKey);
                document.body.style.overflow = "";
            }
        });
        onUnmounted(() => {
            document.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createVNode(_Transition, {
                    "enter-active-class": "transition-opacity duration-200 ease-out",
                    "leave-active-class": "transition-opacity duration-150 ease-in",
                    "enter-from-class": "opacity-0",
                    "leave-to-class": "opacity-0"
                }, {
                    default: _withCtx(() => [
                        (__props.open)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createCommentVNode(" Backdrop "),
                                _createVNode(_Transition, {
                                    appear: "",
                                    "enter-active-class": "modal-backdrop-enter",
                                    "leave-active-class": "modal-backdrop-leave",
                                    "enter-from-class": "modal-backdrop-hidden",
                                    "leave-to-class": "modal-backdrop-hidden"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", {
                                            class: "modal-backdrop absolute inset-0",
                                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createCommentVNode(" Panel "),
                                _createElementVNode("div", _hoisted_2, [
                                    _createCommentVNode(" Top accent "),
                                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "h-1 w-full bg-accent" }, null, -1 /* CACHED */)),
                                    _createCommentVNode(" Header "),
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("h3", _hoisted_4, _toDisplayString(text.value.nav.skills), 1 /* TEXT */),
                                            (__props.study)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.study), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('close'))),
                                            "aria-label": "Close",
                                            class: "shrink-0 p-2 hover:bg-black/5 dark:hover:bg-white/5 hover:text-accent transition-colors duration-300 focus:outline-none"
                                        }, [
                                            _createVNode(_unref(Icon), {
                                                icon: "ph:x-bold",
                                                class: "w-6 h-6"
                                            })
                                        ])
                                    ]),
                                    _createCommentVNode(" Study skills "),
                                    _createElementVNode("div", _hoisted_6, [
                                        (__props.skills && __props.skills.length)
                                            ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.skills, (skill) => {
                                                    return (_openBlock(), _createElementBlock("li", {
                                                        key: skill.name,
                                                        class: "flex items-center justify-between gap-3 border-b border-black/5 dark:border-white/5 pb-2.5"
                                                    }, [
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass(["text-sm font-medium",
                                                                skill.status === 'in_progress'
                                                                    ? 'opacity-60'
                                                                    : ''
                                                            ])
                                                        }, _toDisplayString(skill.name), 3 /* TEXT, CLASS */),
                                                        (skill.status === 'in_progress')
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(text.value.aboutMe.inProgress), 1 /* TEXT */))
                                                            : (_openBlock(), _createBlock(_unref(Icon), {
                                                                key: 1,
                                                                icon: "ph:check-bold",
                                                                class: "shrink-0 w-4 h-4 text-accent"
                                                            }))
                                                    ]));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_9, "—"))
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
